/**
 * Save and restore selection in a DFGrid. Supports only single selection.
 * Ensures there is always a selection, so will select the first item on restore,
 * if none is selected.
 *
 * Save
 * -Capture the current selected item
 *
 * Restore
 * -Saved called with no rows
 * -- Have rows: select first
 * -- Have no rows: do nothing
 * -Have saved item
 *  --Saved item still exists
 *      ---Something already selected: do nothing
 *      ---Nothing selected: select saved item
 *  --Saved item does not still exist
 *      ---Something already selected: do nothing
 *      ---Have first item: select it
 *      ---Else: clear selection
 * -Do not have saved item
 *  --have selection: do nothing
 *  --do no have selection; have first row: select first row
 *  -- no rows: clear selection
 */


/**
 * Create a saved selection. Must call save() manually.
 * @param grid grid to operate on
 * @constructor
 */
var Selection = function(grid) {
    this.grid = grid;
    this.ids = new Set();
    this.uids = new Set();
};

/**
 * Check for current selection.  If a selection exists, do nothing.  If no selection exists, but rows exist, select first row.
 * Otherwise, clear the selection.
 * @private
 */
Selection.prototype._ensureSelection = function() {
    var rows = this.grid.tbody.find("tr[data-uid]");
    if (rows.length) {
        // if the grid has an option to allow empty selection, select nothing.
        if (this.grid.getOptions().keepSelectionOnRefresh === "allowEmpty") {
            this.grid.clearSelection();
        } else {
            this.grid.select(rows[0]);
        }
    } else if (!this.skip) {
        this.grid.clearSelection();
    }
};

/**
 * Save the current selection.
 */
Selection.prototype.save = function() {
    this.ids.clear();
    this.uids.clear();
    this.skip = false;
    var item;
    var selected = this.grid.select();
    for (var i = 0; i < selected.length; i++) {
        item = this.grid.dataItem(selected[i]);
        if (item) {
            this.ids.add(item.get(item.idField));
            this.uids.add(item.uid);
        }
    }
    if (this.grid.tbody.find("tr").length == 0) {
        this.skip = true;
    }
};

/**
 * Restore the saved selections.
 */
Selection.prototype.restore = function() {
    if (this.grid.select().length) {
        return;
    }
    var rows = this.grid.tbody.find("tr[data-uid]");
    var item,
        selected = false;
    for (var i = 0; i < rows.length; i++) {
        item = this.grid.dataItem(rows[i]);
        if (item && ((item.idField && item.get(item.idField) && this.ids.has(item.get(item.idField))) || this.uids.has(item.uid))) {
            this.grid.select(rows[i]);
            selected = true;
        }
    }

    if (!selected) {
        this._ensureSelection();
    }
};

export default Selection;
